var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import Brushaway from '@components/Brushaway';
import TextInput from '@components/TextInput/TextInput';
import InputTextArea, { StyleVariant } from '@components/InputTextArea/InputTextArea';
import { Button } from '@ui';
import ColorPicker from '@components/v2/ColorPicker';
import { useCreateComponentStatusMutation } from '../hooks/useComponentStatusesMutations';
import './AddComponentStatusModalStyles.scss';
export default function AddComponentStatusModal({ isOpen, onClose }) {
    const createMutation = useCreateComponentStatusMutation();
    const { control, handleSubmit, reset, setValue, formState: { errors, isSubmitting } } = useForm({
        defaultValues: {
            status: '',
            color: '#3366cc',
            description: ''
        }
    });
    const onSubmit = (data) => __awaiter(this, void 0, void 0, function* () {
        const requestData = {
            status: data.status,
            color: data.color,
            description: data.description || undefined
        };
        try {
            yield createMutation.mutateAsync(requestData);
            handleClose();
        }
        catch (error) {
            // Error handling is done in the mutation hook via toast
            console.error('Failed to create component status:', error);
        }
    });
    const handleClose = () => {
        reset({
            status: '',
            color: '#3366cc',
            description: ''
        });
        onClose();
    };
    // Wrapper for form submit to handle void return type
    const handleFormSubmit = (e) => {
        void handleSubmit(onSubmit)(e);
    };
    // Wrapper for button click to handle void return type
    const handleButtonSubmit = () => {
        void handleSubmit(onSubmit)();
    };
    // Handle color picker changes
    const handleColorChange = (event) => {
        setValue('color', event.value);
    };
    const isLoading = isSubmitting || createMutation.isLoading;
    return (React.createElement(Brushaway, { open: isOpen, title: "Create New Status", onClose: handleClose, isForm: true, customFooter: React.createElement(React.Fragment, null,
            React.createElement(Button, { onClick: handleClose, disabled: isLoading }, "Cancel"),
            React.createElement(Button, { variant: "primary", onClick: handleButtonSubmit, disabled: isLoading }, isLoading ? 'Creating...' : 'Create')) },
        React.createElement("div", { className: "add-component-status-modal" },
            React.createElement("div", { className: "modal-description" }, "Component Statuses define the operational states for tracking and reporting. Upon creation, you'll be able to set a component to this status throughout Inspect Point."),
            React.createElement("form", { className: "add-component-status-form", onSubmit: handleFormSubmit },
                React.createElement("div", { className: "form-row" },
                    React.createElement(Controller, { name: "status", control: control, rules: { required: 'Status name is required' }, render: ({ field }) => {
                            var _a;
                            return (React.createElement(TextInput, { value: field.value || '', name: field.name, onChange: field.onChange, onBlur: field.onBlur, label: "Status name", error: (_a = errors.status) === null || _a === void 0 ? void 0 : _a.message, required: true }));
                        } })),
                React.createElement("div", { className: "form-row" },
                    React.createElement(Controller, { name: "color", control: control, rules: { required: 'Status color is required' }, render: ({ field }) => {
                            var _a;
                            return (React.createElement(ColorPicker, { value: field.value, onChange: handleColorChange, onBlur: field.onBlur, label: "Status color", error: (_a = errors.color) === null || _a === void 0 ? void 0 : _a.message, required: true }));
                        } })),
                React.createElement("div", { className: "form-row" },
                    React.createElement(Controller, { name: "description", control: control, render: ({ field }) => (React.createElement(InputTextArea
                        // eslint-disable-next-line react/jsx-props-no-spreading
                        , Object.assign({}, field, { label: "Description", variant: StyleVariant.Light, buttonControlled: false }))) }))))));
}
